<script>
  import { _ } from 'svelte-i18n'
  import ExtensionButton from '../../../components/ExtensionButton.svelte'
  import Button from '../../../elements/Button.svelte'
  export let reload_required = false
</script>

{#if !reload_required}
  <h2>
    {$_('inserts.yourFonts.didYou')}<br>
    Install our browser extension to see them here as well.
  </h2>
  <ExtensionButton bind:reload_required/>
  <p>
    <a href="/help/font-detection/" target="_blank">{$_('inserts.yourFonts.readMore')}</a>
  </p>
{:else}
  <h2>
    Please reload this page after installing the extension.<br>
    Also, remember to restart your browser when you install new fonts.
  </h2>
  <Button 
    on:click={() => reload_required = true}
    kind={'accent'}
    href={'/'}>
    {$_('extension.reloadButton')}
  </Button>
  <p class="mt3">
    <a href="/help/font-detection/" target="_blank">{$_('inserts.yourFonts.readMore')}</a>
  </p>
{/if}

<style>
  h2 {
    margin-bottom: 3rem;
  }
  .mt3 {
    margin-top: 3rem;
  }
</style>